import { render, staticRenderFns } from "./BasketProductEditor.vue?vue&type=template&id=378b2650&scoped=true"
import script from "./BasketProductEditor.vue?vue&type=script&lang=js"
export * from "./BasketProductEditor.vue?vue&type=script&lang=js"
import style0 from "./BasketProductEditor.vue?vue&type=style&index=0&id=378b2650&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378b2650",
  null
  
)

export default component.exports